import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import data from "@/data/projects/projects.json";
import PageMeta from "@/components/common/PageMeta";
import Loading from "@/components/common/Loading";
import ProjectsHorizontal from "@/components/portfoliu/projects-horizontal/ProjectsHorizontal";
import Filters from "@/components/portfoliu/filters/Filters";
import Intro from "@/components/service/components/intro/Intro";

const Ecommerce = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    setLoading(false);
  }, []);

  // Filter e-commerce projects
  const ecommerceProjects = data.filter(project => project.type === "ecommerce");

  // Portfolio intro data - Champions League style
  const portfolioIntroData = {
    tag: "E-commerce",
    title: "MAGAZINE ONLINE CHAMPIONS LEAGUE",
    text: "Platforme e-commerce construite să domine piața. Dacă Shopify e un Logan, proiectele noastre sunt McLaren.",
    description: "Custom code, zero limite, zero taxe lunare. Magazine online care înghit concurența."
  };

  if (loading) return <Loading />;

  return (
    <>
      <PageMeta
        title="Proiecte E-commerce Champions League | Pixado"
        description="Magazine online enterprise construite cu tehnologii moderne: React, Next.js, custom platforms. Zero WordPress, zero Shopify."
      />
      <Intro data={portfolioIntroData} />
      <Container style={{ marginTop: "-40px", textAlign: "center" }}>
        <div style={{
          display: "inline-block",
          fontSize: "0.7em",
          transform: "scale(0.85)"
        }}>
          <Filters projects={data} setProjects={() => {}} />
        </div>
      </Container>
      <Container style={{ height: "100%" }}>
        <ProjectsHorizontal projects={ecommerceProjects} />
      </Container>
    </>
  );
};

export default Ecommerce;